document.addEventListener('DOMContentLoaded', function () {
  const newsltr_signup = document.getElementById("home_newsletter_signup");
  if(newsltr_signup) {
    newsltr_signup.querySelector("button[type='submit']").addEventListener("click",(e) => {
      e.preventDefault();
      const captchaResponse = grecaptcha.getResponse();
      
      newsltr_signup.querySelector('.recaptcha-error').classList.remove('active');
      
      if(!newsltr_signup.checkValidity()) {
        newsltr_signup.reportValidity();
        return;
      }
      
      if(!captchaResponse) {
        newsltr_signup.querySelector('.recaptcha-error').classList.add('active');
        return;
      }
      
      newsltr_signup.submit();
    });
  }
});